/// <reference path="koyori.ts" />

/**
 * ボタンコンポーネントです。
 * <dl>
 * <dt>属性</dt>
 * <dd>type: ボタンの種別（submit、reset、button、cancelいずれか）</dd>
 * <dd>state: コンポーネントの色（active、info、warning、errorのいずれか）</dd>
 * <dd>disabled: 無効化</dd>
 * <dd>name: 名前</dd>
 * <dd>href: クリックされた際の遷移先</dd>
 * </dl>
 */
class KoyoriButton extends KoyoriElement {

	static get observedAttributes() {
		return ['type', 'disabled', 'name'];
	}

	/** ボタンエレメント */
	private buttonElement: HTMLElement;

	constructor() {
		super();
	}

	connectedCallback(): void {
		if (this.buttonElement == undefined) {
			this.classList.add('koy-button');

			this.buttonElement = <HTMLElement>this.querySelector('button.koy-button-inner');
			if (this.buttonElement == null) {
				this.buttonElement = document.createElement('button');
				this.buttonElement.classList.add('koy-button-inner');
				this.labelHTML = this.innerHTML;
				this.textContent = '';
				this.appendChild(this.buttonElement);
			}

			this.buttonElement.addEventListener('click', (event: MouseEvent) => {
				if (this.getAttribute('disabled') != null) {
					return;
				}
				this.buttonElement.classList.remove('koy-animation');
				setTimeout(() => {
					this.buttonElement.classList.add('koy-animation');
				}, 10);
				if (this.getAttribute('href') != null) {
					event.preventDefault();
					event.stopPropagation();
					location.href = this.getAttribute('href');
				}
			});

			this.buttonElement.addEventListener('animationend', (event) => {
				this.buttonElement.classList.remove('koy-animation');
			});
		}
		super.connectedCallback();
	}

	/**
	 * フォーカスを当てます。
	 */
	focus(): void {
		this.buttonElement.focus();
	}

	get labelContent(): string {
		return this.buttonElement.textContent;
	}

	set labelContent(text: string) {
		this.buttonElement.textContent = text;
	}

	get labelHTML(): string {
		return this.buttonElement.innerHTML;
	}

	set labelHTML(html: string) {
		this.buttonElement.innerHTML = html;
	}

	get disabled(): boolean {
		return (this.getAttribute('disabled') != null);
	}

	set disabled(value: boolean) {
		if (value) {
			this.setAttribute('disabled', '');
		} else {
			this.removeAttribute('disabled');
		}
	}

	protected typeChanged(value: string): void {
		if (value == 'cancel') {
			value = 'button';
		}
		this.buttonElement.setAttribute('type', value);
	}
	
	protected disabledChanged(value: string): void {
		if (value == null) {
			this.buttonElement.removeAttribute('disabled');
		} else {
			this.buttonElement.setAttribute('disabled', value);
		}
	}

}
window.customElements.define('koy-button', KoyoriButton);
